<template>
  <div class="card-area">
    <form novalidate class="md-layout" @submit.prevent="validateUser">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Step1 of 4</div>
        </md-card-header>
        <md-card-content>
          <div class="md-title">Please provide the following:</div>

          <span class="error_text" v-if="submited & date_false"
            >The Date is required</span
          >
          <br />
          <span class="error_text" v-if="submited & phone_false"
            >The correct Phone Number is required</span
          >

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('firstName')">
                <label for="first-name">First Name</label>
                <md-input
                  name="first-name"
                  id="first-name"
                  autocomplete="given-name"
                  v-model="form.firstName"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.firstName.required"
                  >The first name is required</span
                >
                <span class="md-error" v-else-if="!$v.form.firstName.minlength"
                  >Invalid first name</span
                >
              </md-field>
            </div>

            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('lastName')">
                <label for="last-name">Last Name</label>
                <md-input
                  name="last-name"
                  id="last-name"
                  autocomplete="family-name"
                  v-model="form.lastName"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.lastName.required"
                  >The last name is required</span
                >
                <span class="md-error" v-else-if="!$v.form.lastName.minlength"
                  >Invalid last name</span
                >
              </md-field>
            </div>
          </div>

          <div>
            <md-datepicker v-model="selectedDate" md-immediately :md-model-type="String">
              <label>Select date</label>
              <span class="md-error">The last name is required</span>
            </md-datepicker>
          </div>
          <div>
            <vue-phone-number-input v-model="phoneNumber" @update="onUpdate">
              <label>Phone Number</label>
              <span class="md-error">The last name is required</span>
            </vue-phone-number-input>
          </div>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button type="submit" class="md-primary">Next</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "InputUserData",
  props: {
    msg: String,
  },
  component: {},
  mixins: [validationMixin],
  data: () => ({
    form: {
      firstName: null,
      lastName: null,
    },
    userSaved: false,
    sending: false,
    lastUser: null,
    phoneNumber: null,
    selectedDate: null,
    submited: false,
    date_false: false,
    phone_false: false,
    phoneResult: null,
  }),
  validations: {
    form: {
      firstName: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      },
    },
  },

  mounted() {
    this.form.firstName = this.$route.params.firstName;
    this.form.lastName = this.$route.params.lastName;
    this.selectedDate = this.$route.params.date;
    this.phoneNumber = this.$route.params.phoneNumber;
  },

  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.firstName = null;
      this.form.lastName = null;
    },
    saveUser() {
    console.log(this.phoneNumber);
      this.submited = true;
      if (this.selectedDate == null) {
        this.date_false = true;
        return;
      }
      if (this.phoneResult == null) {
        this.phone_false = true;
        return;
      } else if (this.phoneResult.isValid == false) {
        this.phone_false = true;
        return;
      }
      this.phone_false = false;
      this.date_false = false;
      this.sending = true;

      // Instead of this timeout, here you can call your API
      window.setTimeout(() => {
        this.lastUser = `${this.form.firstName} ${this.form.lastName}`;
        this.userSaved = true;
        this.sending = false;
        this.$router.push({
          name: "ConfirmUserData",
          params: {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            date: this.selectedDate,
            phoneNumber: this.phoneNumber,
          },
        });
      }, 1500);
    },
    onUpdate(payload) {
      this.phoneResult = payload;
    },
    validateUser() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveUser();
      }
    },
  },
};
</script>

<style lang="css" scoped>
/* .error_text {
  color: red;
}

.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-card-actions {
  flex-direction: column;
}
.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}
.md-card {
  display: inline-block;
  padding: 20px;
}
.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}
.md-layout-item.md-size-50 {
  min-width: 100%;
  max-width: 50%;
} */
</style>